"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SkeletonTableRow;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
function SkeletonTableRow({}) {
    return (react_1.default.createElement(TableRow_1.default, null,
        react_1.default.createElement(TableCell_1.default, { width: "5%" },
            react_1.default.createElement(material_1.Skeleton, null)),
        react_1.default.createElement(TableCell_1.default, { width: "35%" },
            react_1.default.createElement(material_1.Skeleton, null)),
        react_1.default.createElement(TableCell_1.default, { width: "20%" },
            react_1.default.createElement(material_1.Skeleton, null)),
        react_1.default.createElement(TableCell_1.default, { width: "20%" },
            react_1.default.createElement(material_1.Skeleton, null)),
        react_1.default.createElement(TableCell_1.default, { width: "10%" },
            react_1.default.createElement(material_1.Skeleton, null))));
}
